export default __webpack_public_path__ + "static/media/image.5e03d9ba.png";